module.exports = __webpack_public_path__ + "static/tfk-cover-e5750bb1c044023b10f174c9c39e0d64.jpg";